import axiosService from '@services/axiosService';
import { MULTI_FACTOR_AUTH_ATTEMPTS_FAILED_LIMIT } from '@config/modelsConfig';

// TODO: #703 implement properly
export const getBlockedAttendees = (token) =>
  axiosService.get(
    `/api/AppUser/?filter=${JSON.stringify({
      where: {
        email: { nlike: encodeURI('archived_%') },
        MFAAttemptsFailed: { gt: MULTI_FACTOR_AUTH_ATTEMPTS_FAILED_LIMIT }, // ??
        // role: 'Attendee' // ??
      },
      include: 'roles', // Attendees only?
    })}&access_token=${token}`,
  );

// TODO: #703 implement
export const unblockAttendee = (userId, token) =>
  axiosService.post(`/api/AppUser/${userId}/unblock?access_token=${token}`);



// WEBPACK FOOTER //
// ./services/blockedAttendeesResource.js